export const HOME_LATEST_RELEASE_AMOUNT = 10;